export const URL_FINANZAS = process.env.REACT_APP_URL_FINANZAS;

export const auth = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

export const redondea = (v) => Math.round((Number(v) || 0) * 100) / 100;

export const fmt = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(v) || 0);

export const fmtCorto = (v) => {
  const n = Math.abs(Number(v) || 0);
  if (n >= 1e9) return `$${(v / 1e9).toFixed(1)}B`;
  if (n >= 1e6) return `$${(v / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `$${(v / 1e3).toFixed(0)}K`;
  return `$${Math.round(v)}`;
};

export const FORMAS_PAGO = ["Transfer", "Efectivo", "TDC", "Bonificacion"];

// Reparte un importe de lo más viejo a lo más nuevo: la lista ya viene ordenada por fecha
export const reparte = (lista, monto) => {
  let resta = redondea(monto);
  return lista.map((f) => {
    const importe = Math.min(resta, Math.max(redondea(f.saldo), 0));
    resta = redondea(resta - importe);
    return { ...f, importe };
  });
};

export const COLOR_ESTADO = { "Con saldo": "warning", Liquidado: "success", "Sin cargos": "secondary" };
export const COLOR_CLASE = { Nota: "primary", Cargo: "warning", Abono: "success", Gasto: "secondary", Pago: "info" };
